import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunglasses = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M8 4h-2l-3 10" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 4h2l3 10" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 16h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 14l4.5 4.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 14l4.5 4.5" })
	]
});
export { SvgSunglasses as ReactComponent };
